import secondaryComponents from "../../../../../components/secondaryComponents";
import primaryComponents from "../../../../../components/primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { motion } from "framer-motion";
import { useAllConnections } from "./useAllConnections";
import styles from "./styles.module.scss";
import {
  ConnectStoreIcon,
  EmptyShippingIcon,
} from "../../../../../assets/svgIcons";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../routes/pathContants";

const Connections = () => {
  const navigate = useNavigate();
  const {
    search,
    storesMappingList,
    metaDetails,
    instance,
    deleteStoresMapping,
    deleteConnection,
    setDeleteConnection,
    handleDeleteConnection,
    gotoPage,
    searchConncections,
  } = useAllConnections();

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <secondaryComponents.RequestLoaderTrigger>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.3 } }}
        className={`${globalStyles.pageColumnGaps}`}
      >
        <div className={globalStyles.pageHeaders}>
          <p>
            {storesMappingList?.length} Connection
            {storesMappingList?.length > 1 ? "s" : ""}
          </p>
          <primaryComponents.Button
            classNames={"btn btn--primary"}
            onClick={() =>
              navigate(`${pathConstants.APPS_CHOWDECK_API_MANAGEMENT}`)
            }
          >
            <span className="mr-1">
              <ConnectStoreIcon color="white" />
            </span>
            Connect Store
          </primaryComponents.Button>
        </div>
        <div className={styles.content}>
          <div className={`${globalStyles.tableHeader}`}>
            <primaryComponents.SearchField
              value={search.get("query") || ""}
              placeholder={"Search for a connection"}
              triggerOnInput={true}
              showsearchBtn={true}
              trigger={(value) => searchConncections(value)}
              classNames={`${globalStyles.searchField}`}
            />
          </div>
          <div>
            <secondaryComponents.TableHelper
              getTableProps={getTableProps}
              getTableBodyProps={getTableBodyProps}
              headerGroups={headerGroups}
              rows={rows}
              prepareRow={prepareRow}
              hasAction={true}
            >
              <div className="text-center mt-5">
                <EmptyShippingIcon />
                <h5>You have no Connections</h5>
                <p>
                  Use the button above to add to connect stores. When you do,
                  they will appear here.
                </p>
              </div>
            </secondaryComponents.TableHelper>
            <secondaryComponents.Pagination
              totalPageNumber={metaDetails?.last_page}
              handlePageClick={(value) => gotoPage(value?.selected + 1)}
              currentPage={metaDetails?.current_page}
            />
          </div>
        </div>
      </motion.div>
      <secondaryComponents.ConfirmDialog
        title="Delete Connection"
        isOpen={deleteConnection ? true : false}
        setIsOpen={setDeleteConnection}
        isLoading={deleteStoresMapping.isLoading}
        handler={handleDeleteConnection}
      >
        <p className="text-center">
          Are you sure you want to delete this connection?
        </p>
        <p className="text-center">This action can not be undone</p>
      </secondaryComponents.ConfirmDialog>
    </secondaryComponents.RequestLoaderTrigger>
  );
};

export default Connections;
